import React, { ReactNode } from "react";

const containerClass =
  "relative rounded-[5px] bg-[var(--bg-color)] p-[10px] shadow-[0px_5px_14px_0px_rgba(0,0,0,0.05)]";

function Container({
  children,
  className,
}: {
  children: ReactNode;
  className?: string | null;
}) {
  return (
    <div className={[containerClass, className ?? ""].filter(Boolean).join(" ")}>
      {children}
    </div>
  );
}

export default Container;
